import { Grid, Typography } from '@mui/material'
import ListExtensions from './ListExtensions'
import useStyleSecurity from './Styles/useStyle'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getAllFileExtends } from '../../../redux/actions/Security'
import InfoIcon from '@mui/icons-material/Info'

export default function AdminExtensions () {
  const dispatch = useDispatch()
  const [fileExtensions, setFileExtensions] = useState([])
  const classes = useStyleSecurity()

  useEffect(async () => {
    setFileExtensions(await dispatch(getAllFileExtends()))
  }, [])

  return (
    <div className={classes.backgroundBox}>
      <div className={classes.titleStyle}>
        <Typography className={classes.titleTypography}>
          Administración de extensiones de archivos
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
        En esta sección puede administrar las extensiones habilitadas
          para la aplicación Mi Estudio
        </Typography>
      </div>
      <div className={classes.instructionsBox}>
        <Typography className={classes.helpTypography}>

        </Typography>
      </div>
      <Grid container className={classes.containerStyle}>
        <Grid className={classes.containerStyle2} xs={10} item>
          <ListExtensions lista={fileExtensions} />
        </Grid>
      </Grid>
    </div>
  )
}
